import { z } from 'zod';
import { StylePresetSchema } from './styles.js';

/**
 * Request shape for /suggest — the "Surprise me" feature on NewGeneration.
 * Claude sees the optional reference image (the user's selected NFT), reads
 * its vibe, and returns ONE fresh scene prompt with a matching style preset.
 *
 * The character image is multimodal context only; Claude never names the
 * character in the sketch — sketches describe SCENES, not subjects. The
 * amplifier handles inserting the character later.
 */
export const SuggestRequestSchema = z.object({
  referenceImageUrl: z.string().url().nullable().default(null),
  recentSketches: z.array(z.string().max(300)).max(5).optional(),
});
export type SuggestRequest = z.infer<typeof SuggestRequestSchema>;

export const SuggestResponseSchema = z.object({
  sketch: z.string().min(1).max(300),
  stylePreset: StylePresetSchema,
});
export type SuggestResponse = z.infer<typeof SuggestResponseSchema>;
